const en = {
  durationTxt: 'Complete setup from ground-up',
  costTxt: 'Setup cost range',
  niceToHaveTxt: 'Nice to have',
  mustHaveTxt: 'Must have',
  sectionTitle: 'Pyramid of Operational Needs',
  learnMoreTxt: 'Click to learn more',
};

export default en;
